import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Memos } from '../actions';
import { filter, tap } from 'rxjs';

import confetti from 'canvas-confetti';
import { Injectable } from '@angular/core';

const particleCount = 200;
const particleDefaults = {
  origin: { y: 0.7 },
};

@Injectable()
export class CelebrationEffects {
  constructor(private actions: Actions) {}

  animatedCategoryConfetti$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(Memos.RESPONSE_SUCCESS_CREATE),
        filter((action: any) =>
          action.payload.categories.find((c) => c.name === 'Olympics' || c.name === 'Halloween')
        ),
        tap((action) => {
          this.confetti();
        })
      ),
    { dispatch: false }
  );

  /**
   * A nice looking confetti effect.
   *
   * The code below is an example from the canvas confetti docs:
   * https://www.kirilv.com/canvas-confetti/#realistic
   */
  confetti() {
    function go(particleRatio, opts) {
      confetti({
        ...particleDefaults,
        ...opts,
        particleCount: Math.floor(particleCount * particleRatio),
      });
    }

    go(0.25, {
      spread: 26,
      startVelocity: 55,
    });
    go(0.2, {
      spread: 60,
    });
    go(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
    });
    go(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
    });
    go(0.1, {
      spread: 120,
      startVelocity: 45,
    });
  }
}
